import { fetchMapboxDrivingRoute } from './mapboxDirections';

/** Read trip miles from API job payload when present (miles; values > 1000 treated as meters). */
export const parseTripMilesFromJob = job => {
  if (!job) {
    return null;
  }

  const candidates = [job.distance, job.actual_distance, job.mileage, job.trip_miles, job.scheduled_distance];
  for (const raw of candidates) {
    if (raw == null || raw === '') {
      continue;
    }
    let miles = parseFloat(raw);
    if (!Number.isFinite(miles) || miles <= 0) {
      continue;
    }
    if (miles > 1000) {
      miles /= 1609.34;
    }
    return parseFloat(miles.toFixed(2));
  }
  return null;
};

const getJobCoords = job => ({
  startLon: job.start_lon / 1000000.0,
  startLat: job.start_lat / 1000000.0,
  endLon: job.end_lon / 1000000.0,
  endLat: job.end_lat / 1000000.0,
});

/** Fill missing distance on route-map jobs using lookup map, then Mapbox driving distance. */
export const enrichRouteViewJobsWithTripMiles = async (jobs, distanceByJobId = {}) => {
  if (!jobs?.length) {
    return [];
  }

  const enriched = [];
  for (const job of jobs) {
    let miles =
      distanceByJobId[job.id] ??
      distanceByJobId[String(job.id)] ??
      parseTripMilesFromJob(job);

    if (!Number.isFinite(miles) || miles <= 0) {
      const { startLon, startLat, endLon, endLat } = getJobCoords(job);
      if (startLon && startLat && endLon && endLat) {
        const route = await fetchMapboxDrivingRoute(startLon, startLat, endLon, endLat);
        miles = route?.distance ?? 0;
      } else {
        miles = 0;
      }
    }

    enriched.push({
      ...job,
      distance: parseFloat(Number(miles).toFixed(2)),
    });
  }

  return enriched;
};
